import { Option, OptionValueType } from './types.ts';
import { translations } from '../translations/translations';
import { ClockClockwise, ClockCounterClockwise } from '@phosphor-icons/react';
import { ExButton } from '@boomi/exosphere';

interface Props {
    id: string;
    option: Option;
    value: number | null | undefined;
    onChange: (id: string, value: OptionValueType) => void;
    language?: string;
}

const TimeOffset = ({ id, option, value, onChange, language = 'en' }: Props) => {
    const timeOffsetOptions = [
        { id: 'option_five', label: translations[language].TIME_OFFSET_5min, value: 5 },
        { id: 'option_ten', label: translations[language].TIME_OFFSET_10min, value: 10 },
        { id: 'option_fifteen', label: translations[language].TIME_OFFSET_15min, value: 15 },
        { id: 'option_thirty', label: translations[language].TIME_OFFSET_30min, value: 30 },
        { id: 'option_hour', label: translations[language].TIME_OFFSET_1hour, value: 60 },
        { id: 'option_day', label: translations[language].TIME_OFFSET_1day, value: 1440 },
    ];

    return (
        <div className="time-offset">
            {/* Time offset options */}
            <section className="offset select-buttons">
                {timeOffsetOptions.map((offset) => (
                    <label htmlFor={id + offset.id} key={id + offset.id} className="text sm">
                        {offset.label}
                        <input
                            type="radio"
                            id={id + offset.id}
                            name={id + 'timeOffsetValue'}
                            value={offset.value}
                            onChange={() =>
                                onChange(
                                    option.id,
                                    // if no value selected start with before (- value)
                                    !value
                                        ? offset.value * -1
                                        : value > 0
                                          ? offset.value
                                          : offset.value * -1,
                                )
                            }
                            checked={!!value && Math.abs(value) === offset.value}
                        />
                    </label>
                ))}
            </section>
            {/* Time offset direction */}
            <section className="direction select-buttons">
                <label htmlFor={id + 'before'} className="text sm">
                    <ClockCounterClockwise size={24} />
                    {translations[language].TIME_OFFSET_before}
                    <input
                        type="radio"
                        id={id + 'before'}
                        name={id + 'timeOffsetDirection'}
                        value="before"
                        onChange={() =>
                            !!value && onChange(option.id, value > 0 ? value * -1 : value)
                        }
                        checked={!!value && value < 0}
                    />
                </label>
                <label htmlFor={id + 'after'} className="text sm">
                    <ClockClockwise size={24} />
                    {translations[language].TIME_OFFSET_after}
                    <input
                        type="radio"
                        id={id + 'after'}
                        name={id + 'timeOffsetDirection'}
                        value="after"
                        onChange={() =>
                            !!value && onChange(option.id, value > 0 ? value : value * -1)
                        }
                        checked={!!value && value > 0}
                    />
                </label>
                <ExButton
                    className="exo-button"
                    flavor="branded"
                    type="tertiary"
                    size="large"
                    onClick={() => onChange(option.id, null)}
                >
                    {translations[language].TIME_OFFSET_clear}
                </ExButton>
            </section>
        </div>
    );
};

export default TimeOffset;
